import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const FullscreenOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function FullscreenOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M5.5 12h2V9h3V7h-5v5ZM16.5 15h-3v2h5v-5h-2v3Z" />
          <path d="M18 2.5H6c-2.76 0-5 2.24-5 5v9c0 2.76 2.24 5 5 5h12c2.76 0 5-2.24 5-5v-9c0-2.76-2.24-5-5-5Zm3 14c0 1.65-1.35 3-3 3H6c-1.65 0-3-1.35-3-3v-9c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3v9Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default FullscreenOutlined;